import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { PageBase, AuthService, ObjectTypeClassInfo, PhotoAngleInfo, SafetyCheckQuestionInfo } from 't4core';
import { ActivatedRoute, Router } from '@angular/router';
import { ObjectTypeClassAttributesInfo } from '../../../../../dist/t4core';
import { FormBuilder, FormControl, FormGroup, NgModel, Validators } from '@angular/forms';
import { ObjectTypeClassAttributeDialog } from '../../dialogs/ObjectTypeClassAttributeDialog/ObjectTypeClassAttributeDialog';
import { PhotoAngleDialog } from '../../dialogs/PhotoAngleDialog/PhotoAngleDialog';
import { SafetyCheckQuestionDialog } from '../../dialogs/SafetyCheckQuestionDialog/SafetyCheckQuestionDialog';

@Component({
  styleUrls: ['ObjectTypeClassDetails.css'],
  selector: 'ObjectTypeClassDetails',
  templateUrl: 'ObjectTypeClassDetails.html',
})

export class ObjectTypeClassDetails extends PageBase {

  public objectTypeClassAttributes: ObjectTypeClassAttributesInfo[];
  public objectTypeClass: ObjectTypeClassInfo;
  public objectTypeClassPhotoAngles: PhotoAngleInfo[];
  public objectTypeClassSafetyQuestions: SafetyCheckQuestionInfo[];


  public typeClassId: any;
  constructor(el: ElementRef, private router: Router, private route: ActivatedRoute, private authService: AuthService) {

    super(el);

  }
  async ngOnInit() {
    this.route.params.subscribe(async params => {
      if (params.Id && params.Id != "") this.typeClassId = params.Id;
    });
    await this.getObjectTypeClassInfo();
    await this.getPhotoAngles();
    await this.getSafetyCheckQuestions();
  }

  public async getObjectTypeClassInfo() {
    this.objectTypeClass = await this.Api.get<ObjectTypeClassInfo>("Settings/GetObjectTypeClassesById", { Id: this.typeClassId });
    console.log("object class", this.objectTypeClass);
    if (this.objectTypeClass) this.objectTypeClassAttributes = [...this.objectTypeClass.Attributes]; 
    
  }
  public async getPhotoAngles() {
    this.objectTypeClassPhotoAngles = await this.Api.get<PhotoAngleInfo[]>("Rental/GetPhotoAnglesForType", { typeClassId: this.typeClassId });
   
  }
  public async getSafetyCheckQuestions() {
    this.objectTypeClassSafetyQuestions = await this.Api.get<SafetyCheckQuestionInfo[]>("Rental/GetSafetyCheckQuestionsForType", { typeClassId: this.typeClassId });

  }

  public async update() {
    var token = this.UI.beginLoading("T4.Settings.CreateObjectTypeClassDialog.msgCreating", "Saving Object Type class", null);
    var res = await this.Api.post<any>("Settings/SaveObjectTypeClass", this.objectTypeClass);
    this.UI.loaderCompleted(token);
  }

  public async openObjectTypeClassAttribute(typeClassAttr: ObjectTypeClassAttributesInfo) {
    var res = await this.Dialog.open(ObjectTypeClassAttributeDialog, { data: { objectTypeClassAttr: typeClassAttr, typeClassId: this.typeClassId, typeClassAttributes: this.objectTypeClassAttributes } }).afterClosed().toPromise();
    var token = this.UI.beginLoading("T4.Settings.CreateObjectTypeClassDialog.msgUpdatingAttr", "Updating Object Type class attributes", null);
    this.objectTypeClassAttributes = await this.Api.get<ObjectTypeClassAttributesInfo[]>("Settings/GetObjectTypeClassAttributesByClassId", { classId: this.typeClassId });
    this.UI.loaderCompleted(token);
  }

  public async deleteObjectTypeClassAttribute(typeClassAttr: ObjectTypeClassAttributesInfo) {
    var d = await this.UI.confirm("T4.Settings.CreateObjectTypeClassDialog.titleConfirmDelete", "Confirm deletion", "T4.Settings.CreateObjectTypeClassDialog.msgConfirmDelete", "Do you want to remove this Attribute?");
    if (d) {
      var token = this.UI.beginLoading("T4.Settings.CreateObjectTypeClassDialog.msgDeletingAttr", "Deleting Object Type class attributes", null);
      var res = await this.Api.delete<boolean>("Settings/DeleteObjectTypeClassAttributes", { attrId: typeClassAttr.Id });
      this.objectTypeClassAttributes = await this.Api.get<ObjectTypeClassAttributesInfo[]>("Settings/GetObjectTypeClassAttributesByClassId", { classId: typeClassAttr.ObjectTypeClassId });
      this.UI.loaderCompleted(token);
    }
  }

  public async openObjectTypePhotoAngles(photoAngle: PhotoAngleInfo) {
    var res = await this.Dialog.open(PhotoAngleDialog, { data: { photoAngleData: photoAngle, showObjectClasses: false, typeClassId: this.typeClassId } }).afterClosed().toPromise();
    var token = this.UI.beginLoading("T4.Settings.CreateObjectTypeClassDialog.msgLoadingPA", "Loading Object Type class photo angles", null);
    await this.getPhotoAngles();
    this.UI.loaderCompleted(token);
  }


  public async deletePhotoAngle(photoAngle: PhotoAngleInfo) {
    var d = await this.UI.confirm("T4.Settings.CreateObjectTypeClassDialog.titleConfirmDelete", "Confirm deletion", "T4.Settings.CreateObjectTypeClassDialog.msgConfirmDeletePA", "Do you want to remove this Photo angle?");
    if (d) {
      var token = this.UI.beginLoading("T4.Settings.CreateObjectTypeClassDialog.msgDeletingPA", "Deleting Object Type class photo angle", null);
      var res = await this.Api.delete<boolean>("Rental/DeletePhotoAngle", { angleId: photoAngle.Id });
      await this.getPhotoAngles();
      this.UI.loaderCompleted(token);
    }
    
  }

  public async openObjectTypeSafetyCheckQuestions(safetyCheckQuestion: SafetyCheckQuestionInfo) {
    var res = await this.Dialog.open(SafetyCheckQuestionDialog, { data: { safetyCheckQuestionData: safetyCheckQuestion, showObjectClasses: false, typeClassId: this.typeClassId } }).afterClosed().toPromise();
    var token = this.UI.beginLoading("T4.Settings.CreateObjectTypeClassDialog.msgLoadingSCQ", "Loading Object Type class safety check questions", null);
    await this.getSafetyCheckQuestions();
    this.UI.loaderCompleted(token);
  }

  public async deleteSecurityCheckQuestion(safetyCheckQuestion: SafetyCheckQuestionInfo) {
    var d = await this.UI.confirm("T4.Settings.CreateObjectTypeClassDialog.titleConfirmDelete", "Confirm deletion", "T4.Settings.CreateObjectTypeClassDialog.msgConfirmDeleteSCQ", "Do you want to remove this Safety check question?");
    if (d) {
      var token = this.UI.beginLoading("T4.Settings.CreateObjectTypeClassDialog.msgDeletingSCA", "Deleting Object Type class safety check question", null);
      var res = await this.Api.delete<boolean>("Settings/DeleteSafetyCheckQuestion", { safetyCQId: safetyCheckQuestion.Id });
      await this.getSafetyCheckQuestions();
      this.UI.loaderCompleted(token);
    }

  }
}
